import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoriaService } from 'src/app/services/categorias/categoria';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { FechasService } from 'src/app/services/fechas/fechas';

@Component({
  selector: 'app-anexo',
  templateUrl: './anexo.component.html',
  styleUrls: ['./anexo.component.css'],
  providers: [CategoriaService, MessageService, FechasService]
})
export class AnexoComponent implements OnInit, OnChanges {

  @Input() displayAnexo: boolean;
  @Input() categoria = "";
  public oldCategoria = "";
  public date: Date = new Date();
  public rev = "";
  @Output() cerrarAnexo = new EventEmitter();
  //public fechaAnexo=new Date();


  ngOnChanges(changes: SimpleChanges) {
    this.anexos();
    if (this.oldCategoria != this.categoria) {
      this.oldCategoria = this.categoria;
      this.date = new Date();
    }


  }

  public registro = {
    fecha_anexo: new Date(),
    categoria: ""
  };
  public mostrarInfo = false;
  public cols: any[] = [];
  public resultado: any[] = [];
  public registros: any[] = [
    {
      fecha_anexo: new Date(),
      categoria: ""
    }
  ];
  public click: Subscription;
  public es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: 'Hoy',
    clear: 'Borrar'
  }
  public fechaCadena = "";
  //public displayAnexo=false;
  public titleAnexo = "";

  constructor(private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private categoriaService: CategoriaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private FechasService: FechasService
  ) {
    this.anexos();
  }

  ngOnInit() {
    this.anexos();
  }

  public anexos() {
    this.displayAnexo = true;
    //let catalogo=window.location.href; 
    this.displayAnexo = false;
    this.titleAnexo = this.location.path(true).replace("/dashboard/", "");
    let contarRutas = this.titleAnexo.split("/");



    if (contarRutas.length == 1) {
      this.displayAnexo = true;
      this.categoria = this.titleAnexo;
      //console.log("title anexo",this.titleAnexo);
      this.categoriaService.listarCategoria(this.titleAnexo).subscribe((data: any) => {
        //console.log("data",data);
        let field = "";
        //console.log("Anexo",data);
        for (let index = 0; index < data.campos.length; index++) {
          field = data.campos[index];
          this.cols.push(field);
          field = "";
        }

        this.resultado = data;
        this.registros = data.producto;
        // console.log("lista ",data,"registro",this.registros);
      }, error => {
        console.log("error ", error);
      });
    }

  }

  verFecha(event) {
    console.log(this.date);
   
      var myfecha = new Date(this.date);
      console.log(myfecha.getDate());
      // console.log(event);
      // console.log(myfecha.getMonth());
      this.date = myfecha;
      let dia = "";
      let mes = "";
      if ((myfecha.getMonth() + 1) < 10) {
        mes = "0" + (myfecha.getMonth() + 1);
      } else {
        mes = "" + (myfecha.getMonth() + 1);
      }
      if ((myfecha.getDate()) < 10) {
        dia = "0" + myfecha.getDate();
      } else {
        dia = "" + myfecha.getDate();
      }
      this.fechaCadena = myfecha.getFullYear() + "/" + mes + "/" + dia;
    
   
    //console.log("date ",this.date)

    //console.log("fecha",pedazos[2]);
  }


  fechaSpanish() {
    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Borrar'
    }
  }


  guardarAnexo() {
    this.verFecha(this.date);
    let mycategoria = {
      "fecha": this.fechaCadena,
      "categoria": this.categoria,
      "rev": this.rev
    }
    if (this.fechaCadena == undefined || this.fechaCadena == "" || this.fechaCadena == null) {
      mycategoria = {
        "fecha": this.FechasService.fechaActual(),
        "categoria": this.categoria,
        "rev": this.rev
      }
    } else {
      mycategoria = {
        "fecha": this.fechaCadena,
        "categoria": this.categoria,
        "rev": this.rev
      }
    }

    // console.log(mycategoria);
    
    this.click = this.categoriaService.createAnexo(mycategoria).subscribe(resp => {

      this.messageService.add({ severity: 'success', summary: 'Anexo', detail: 'Anexo guardado correctamente' });
      this.anexos();
    }, error => {
      console.log("error", error);
    }, () => {
      //console.log("completado");
    });

    this.anexos();
  }

  infoAnexo(registro) {
    this.registro = registro;
    //console.log("registro",this.registro);
    this.registro['fecha_anexo'] = new Date(this.registro['fecha_anexo']);
    this.mostrarInfo = true;
  }

  cerrarVentanaAnexo(event) {
    this.cerrarAnexo.emit({});
  }
  updateAnexo() {
    this.messageService.add({ severity: 'success', summary: 'Anexo', detail: 'Anexo actualizado' });

  }
  cerrarInfoAnexo() {
    this.mostrarInfo = false;
  }

  delete(id) {
    console.log(id);
    this.confirmationService.confirm({
      message: 'Quieres eliminar este anexo?',
      accept: () => {
        this.categoriaService.deleteAnexo(id).subscribe(resp => {
          console.log(resp);
          this.anexos();
        }, error => {
          console.log("error", error);
        });
      }
    });

  }


}
